import { createReducer } from "@reduxjs/toolkit";
import {resetPostOrderStatus } from './OrderAction.js'
import { CancelSQAndSO, convertQuotationToOrder, GetAttachments, GetCustomerData, GetdocType, GetItemByGrp, GetItemBySearch, GetItemGroup, PotingSaleData, UpdateSalesOrder, UpdateSalesQuotation } from "./OrderThunk";

const handleAsyncActions = (builder, action, stateKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[stateKey] = true; // Set loading for specific API
            state[stateKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[stateKey] = false; // Set loading to false when request is fulfilled
            state[stateKey] = action.payload; // Set the fulfilled data
            state.error[errorKey] = null; // Reset error
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[stateKey] = false; // Set loading to false when request fails
            state.error[errorKey] = action.payload; // Set specific error message for the API call
        });
        
};

const initialState = {
    ItemGroup: null,
    ItemByGrp: null,
    CustomerData: null,
    ItemBySearch:null,
    documentType:null,
    PostSalesQ:null,
    UpdateSalesQ:null,
     UpdateSalesOrder:null,
     QuotationToOrderResponse:null,
     QuotationAttachment:null,
     CancelSQAndSOResponse:null,

    // Dynamic loading and error states for each API
    loading: {
        ItemGroup: false,
        ItemByGrp: false,
        ItemBySearch:null,
        CustomerData: false,
        // PostSoOrder:false,
        documentType:false,
        PostSalesQ:false,
        UpdateSalesQ:false,
        UpdateSalesOrder:false,
        QuotationToOrderResponse:false,
        QuotationAttachment:false,
        CancelSQAndSOResponse:false,

    },

    error: {
        ItemGroupError: null,
        ItemByGrpError: null,
        ItemBySearchError:null,
        CustomerDataError: null,
        // PostSoOrderError: null,
        documentTypeError:null,
        PostSaleSQError:null,
        UpdateSaleSQError:null,
        UpdateSalesOrderError:null,
        QuotationToOrderResponse:null,
        QuotationAttachmentError:null,
        CancelSQAndSOResponseError:null,
    },
};

export const orderReducer = createReducer(initialState, (builder) => {
    // Use the utility function to handle async actions
    handleAsyncActions(builder, GetItemGroup, "ItemGroup", "ItemGroupError");
    handleAsyncActions(builder, GetItemByGrp, "ItemByGrp", "ItemByGrpError");
    handleAsyncActions(builder, GetItemBySearch, "ItemBySearch", "ItemBySearchError");
    handleAsyncActions(builder, GetCustomerData, "CustomerData", "CustomerDataError");
    // handleAsyncActions(builder, PostSalesOrder, "PostSoOrder", "PostSoOrderError");
    handleAsyncActions(builder, PotingSaleData, "PostSalesQ", "PostSaleSQError");
    handleAsyncActions(builder, UpdateSalesQuotation, "UpdateSalesQ", "UpdateSaleSQError");
    handleAsyncActions(builder, UpdateSalesOrder, "UpdateSalesOrder", "UpdateSalesOrderError");
    handleAsyncActions(builder, convertQuotationToOrder, "QuotationToOrderResponse", "QuotationToOrderResponse");
    handleAsyncActions(builder, GetAttachments, "QuotationAttachment", "QuotationAttachmentError");
    handleAsyncActions(builder, CancelSQAndSO, "CancelSQAndSOResponse", "CancelSQAndSOResponseError");
    handleAsyncActions(builder, GetdocType, "documentType", "documentTypeError");
    builder.addCase(resetPostOrderStatus, (state, action) => {
        const { key, type } = action.payload;
    
        if (type === "data") {
            state[key] = null;
            if (state.loading && key in state.loading) {
                state.loading[key] = false;
            }
        } else if (type === "error") {
            state.error[key] = null;
            const loadingKey = key.replace("Error", "");
            if (state.loading && loadingKey in state.loading) {
                state.loading[loadingKey] = false;
            }
        }
    });
    

    // builder.addCase(resetPostOrderStatus, (state) => {
    //     state.PostSoOrder = null;
    //     state.PostSalesQ = null;
    //   });
});

export default orderReducer;
